<!-- 验证码登录 -->
<template>
  <div>
    <el-form class="loginaccount" :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item class="login-row" prop="receiveNo">
        <el-input v-model="ruleForm.receiveNo" placeholder="输入手机号" @blur="testItem" />
      </el-form-item>
      <el-form-item label="验证" prop="isLock" v-if="slideShow ? true : false">
        <sliderVerifyCode v-model="ruleForm.isLock" @change="handlerLock"></sliderVerifyCode>
      </el-form-item>

      <el-form-item class="login-row" prop="control">
        <el-input :type="showPwd ? 'text' : 'password'" style="width: 65%" v-model="ruleForm.control"
          placeholder="短信验证码" />
        <el-button type="button" size="small" class="btn btn-info" id="send" :disabled="btnShow ? false : true"
          @click="getCode(ruleForm)">
          <span v-show="count_show">发送验证码</span>
          <span v-show="!count_show" class="count">{{ count }} </span>
        </el-button>
      </el-form-item>
      <el-button :disabled="ruleForm.receiveNo && ruleForm.control ? false : true" class="login-btn" @click="login">
        登录
      </el-button>

      <!-- <div v-else class="login-btn disabled">登录</div> -->

      <div class="login-logon">
        没有账号？<span style="color: red" @click="register">立即注册</span>
      </div>
    </el-form>
  </div>
</template>
<script>
import sliderVerifyCode from "@/components/slider-verify-code.vue";
export default {
  name: "codeLogin",
  components: { sliderVerifyCode },
  props: {},

  data() {
    //const count = 60;  倒计时的时间
    const checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请拖动滑块完成验证"));
      } else {
        if (
          this.ruleForm.receiveNo == "" || !this.ruleForm.receiveNo
        ) {
          setTimeout(() => {
            this.ruleForm.isLock = false;
            this.$refs.ruleForm.validateField("receiveNo");
            return callback(new Error("验证未通过"));
          }, 1);
        }
        callback();
      }
    };

    // 手机号码验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确！"));
      }
      callback();
    };
    return {
      ruleForm: {
        receiveNo: "",
        control: "",
      },
      showPwd: false,
      twoShow: false,
      name: "",
      form: {},
      count: 1,
      btnShow: false,
      slideShow: false,
      count_show: true,
      pwd: "",
      telphone: "",
      rules: {
        receiveNo: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        control: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        isLock: [{ validator: checkStatus, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 验证用户是否注册
    testItem() {
      // console.log('okkkkk')
      this.telphone = this.ruleForm.receiveNo
      if (!/^1[3456789]\d{9}$/.test(this.telphone)) {
        return false;
      }
      this.$axios
        .get(`/weiXin/existenceTel?telphone=${this.telphone}`)
        .then((res) => {
          // console.log(res);
          // console.log(res.code);
          if (res.success) {
            this.$message.error('用户不存在');
          } else {
            // this.$message({
            //   message: res.msg,
            //   type: "success",

            // });
            console.log(res.msg)
            this.slideShow = true
          }
        })
        .catch((err) => {
          alert(err)
          console.log(err);
        });

    },
    // 登录
    login() {
      // var req_url;
      // if ((this.activeName = "登录")) req_url = "/user/login";
      // else req_url = "/user/register"; `/weiXin/loginPass?accoun`
      this.$axios
        .post(`/weiXin/loginCode?telphone=${this.ruleForm.receiveNo}&code=${this.ruleForm.control}`)
        .then((res) => {
          // console.log(res);
          if (res.success) {
            this.$message({
              message: "成功",
              type: "success",
            });

            let data = res.data
            this.userInfo = data
            window.localStorage.setItem('userInfo', JSON.stringify(data))
            window.localStorage.setItem('token', data.token)

            // localStorage.clear();
            window.location.reload()
            let redircetUrl = localStorage.getItem('redircetUrl')
            if (redircetUrl) {
              // window.location.href = redircetUrl
              // localStorage.setItem('redircetUrl', '')
            } else {
              window.location.href = '/'
            }

          } else {
            this.$message.error(res.msg);

          }
        })
        .catch((err) => {
          alert(err)
          console.log(err);
        });
    },
    // 发送验证码
    getCode() {
      this.count = 60; //倒计时时间
      this.count_show = false; //控制倒计时显示隐藏
      var reg_tel = /^(13[0-9]|14[01456789]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-3509])\d{8}$/;
      if (this.ruleForm.receiveNo == '') {
        alert('请填写手机号!');
        return false;
      } else if (!reg_tel.test(this.ruleForm.receiveNo)) {
        alert('请填写正确的手机号!');
        return false;
      }
      console.log(this.ruleForm.receiveNo);
      let params = {
        telphone: this.ruleForm.receiveNo
      }
      this.$axios.get('/weiXin/getCode', { params }).then(res => {
        console.log(res)
        this.btnShow = false
      })

      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--;
        } else {
          clearInterval(this.timer);
          this.btnShow = true
          this.count_show = true;
        }
      }, 1000);
    },
    // 滑动  验证
    handlerLock(data) {
      if (data) {
        this.$refs.ruleForm.validateField("isLock");
      }
      this.btnShow = true;

    },
    // 打开注册页面
    register() {
      // 清空form表单的内容
      this.$refs.ruleForm.resetFields()
      this.twoShow = false;
      this.$emit("transfer", this.twoShow);
    },
    //获取验证码demo
    //   login1() {

    // },
  },

};
</script>
<style lang="scss" scoped>
.loginaccount {
  padding: 0 50px;
}

.login-title {
  padding: 0 50px 50px;
  color: #b2b2b2;
  margin-top: 20px;
}

.codeShow:visited {
  text-decoration: none;
}

.login-row {
  /* margin-top: 78px; */
  // width: 420px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 18px;
  margin-top: 48px;
}

.login-row>>>.el-input__inner {
  font-size: 18px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
  width: 100%;
}

.btn-info {
  float: right;
}

// .inputDeep>>>.el-input__inner {
//     border: 0;
//   }
.login-row .eye-icon {
  width: 24px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
}

.forget {
  font-size: 14px;
  float: right;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
}

.login-btn {
  width: 100%;
  height: 50px;
  background-color: #db3a3b !important;
  margin-top: 30px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff !important;
  cursor: pointer;

  &:hover {
    background-color: #db3a3b !important;
    color: #ffffff !important;
  }
}

.login-btn.disabled {
  background-color: #db3a3b;
  cursor: not-allowed;
}

.login-logon {
  font-size: 14px;
  width: 100%;
  text-align: center;
  padding-top: 20px;
}
</style>>




// WEBPACK FOOTER //
// src/components/codeLogin.vue